<form class="filter-bar" [formGroup]="form" (ngSubmit)="onApply()">
    <!-- Fields -->
    <div class="fields">
        <ng-container *ngFor="let f of fields; let last = last">
            <div class="field">

                <!-- TEXT -->
                <mat-form-field class="pill" *ngIf="f.type==='text'" appearance="outline" [floatLabel]="'never'">
                    <input matInput [placeholder]="f.label" [formControlName]="f.key" />
                </mat-form-field>

                <!-- DATE -->
                <mat-form-field class="pill" *ngIf="f.type==='date'" appearance="outline" [floatLabel]="'never'">
                    <input matInput [matDatepicker]="dp" [placeholder]="f.label" [formControlName]="f.key" />
                    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                    <mat-datepicker #dp></mat-datepicker>
                </mat-form-field>

                <!-- SELECT -->
                <mat-form-field class="pill" *ngIf="f.type==='select'" appearance="outline" [floatLabel]="'never'">
                    <mat-select [placeholder]="f.label" [formControlName]="f.key">
                        <mat-option *ngFor="let o of f.options" [value]="o.value">{{ o.label }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- divider between fields -->
            <div class="divider" *ngIf="!last"></div>
        </ng-container>
    </div>

    <!-- Actions section -->
    <div class="divider"></div>

    <button class="action apply" type="submit">
        <mat-icon>search</mat-icon>
        <span>Apply Filters</span>
    </button>

    <div class="divider"></div>

    <button class="action reset" type="button" (click)="onReset()">
        <mat-icon>restart_alt</mat-icon>
        <span>Reset Filter</span>
    </button>
</form>
